import styled, { css } from 'styled-components';
import { Card } from '../Card/index.js';
import { ShimmerEffect as ShimmerEffect$1 } from '../ShimmerEffect/ShimmerEffect.js';

const Container = styled(Card).withConfig({
    displayName: "ShimmingCard.styles__Container",
    componentId: "sc-4f3046bb-0"
})`
    position: relative;
    overflow: hidden;
    padding: 0px;

    ${({ $loading  })=>$loading ? css`
                  border-width: 0px;
                  padding: 2px;
              ` : ""}

    height: ${({ $height  })=>typeof $height === "number" ? `${$height}px` : "auto"};
`;
const Content = styled.div.withConfig({
    displayName: "ShimmingCard.styles__Content",
    componentId: "sc-4f3046bb-1"
})`
    padding: 16px;
    transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: ${(props)=>props.opacity};
`;
const ShimmerEffect = styled(ShimmerEffect$1).withConfig({
    displayName: "ShimmingCard.styles__ShimmerEffect",
    componentId: "sc-4f3046bb-2"
})`
    border-radius: 8px;
`;

export { Container, Content, ShimmerEffect };
